import { viewType } from '../components/Layout/Layout.types';

export enum Paths {
  adminDashboard = '/adminDashboard',
  annotations = '/annotations',
  assessment = '/assessment',
  assessmentSampleAssessmentGroup = '/assessmentSampleAssessmentGroup',
  calendar = '/calendar',
  cards = '/cards',
  confirmAccount = '/confirm_account',
  confirmEmail = '/confirm_email',
  confirmResetPassword = '/confirm_reset_password',
  context = '/context',
  dashboard = '/dashboard',
  error = '/error',
  examinees = '/examinees',
  examiners = '/examiners',
  examinerTreemap = '/examiner-treemap',
  examinerTreemapForExaminer = '/examiner-treemap-for-examiner',
  health = 'health/live',
  loggedOut = '/loggedOut',
  login = '/login',
  logout = '/logout',
  mailbox = '/mailbox',
  passwordExpired = '/password_expired',
  passwordForcedChange = '/password_forced_change',
  resetPassword = '/reset_password',
  roles = '/roles',
  sampleAssessment = '/sampleAssessment',
  sampleAssessmentGroupSolutionAssignment = '/sampleAssessmentGroupSolutionAssignment',
  sampleAssessmentRepository = '/sampleAssessmentRepository',
  selectEnvironment = '/selectEnvironment',
  serviceError = '/service-error',
  sessions = '/sessions',
  signinOidc = '/signin-oidc',
  silent = '/silent',
  solution = '/solution',
  solutionTabs = '/solution-tabs',
  solutionCard = '/solution-card',
  users = '/users',
  specialCaseCardRedirector = '/specialCaseCard',
  supportPdf = '/support-pdf',
  supportMovies = '/support-movie',
  supportMoviesWatch = '/support-movie/watch',
  examTaskGroupSolutionRedirector = '/examTaskGroupSolution',
  support = '/support',
  supportFaq = '/support-faq',
  supportInstructions = '/support-instructions',
  accessibilityDeclaration = '/deklaracja.html',
  statistics = '/statistics',
}

export const getAssessmentUrl = (assessmentSessionId: string, processTypeId: string, examinerId?: string): string => {
  let examinerIdUrl = '';
  if (examinerId) {
    examinerIdUrl = `/${examinerId}`;
  }
  return `${Paths.assessment}/${assessmentSessionId}/${processTypeId}${examinerIdUrl}`;
};

export const getSampleAssessmentUrl = (assessmentSessionId?: string, examinerId?: string): string => {
  return `${Paths.sampleAssessment}/${assessmentSessionId ? assessmentSessionId : ''}${examinerId ? '/' + examinerId : ''
    }`;
};

export const getSolutionUrl = (
  orgzId: string,
  examinerId?: string,
  processTypeId?: string,
  deskId?: string,
  deskExaminerFunction?: string,
  sheetId?: string,
) => {
  const base = `${Paths.solution}/${processTypeId}/${examinerId}/${orgzId}/${deskId}/${deskExaminerFunction}`;
  return sheetId ? `${base}/${sheetId}` : base;
};

export const getSolutionTabsUrl = (processTypeId?: string, deskId?: string, deskExaminerFunction?: string) => {
  return `${Paths.solutionTabs}/${processTypeId}/${deskId}/${deskExaminerFunction}`;
};

export const getSampleAssessmentGroupSolutionAssignmentUrl = (
  schoolId?: string,
  rgzId?: string,
  examinerId?: string,
) => {
  return `${Paths.sampleAssessmentGroupSolutionAssignment}/${schoolId}/${rgzId}/${examinerId}`;
};

export const getSampleAssessmentRepositoryUrl = (schoolId?: string) => {
  return schoolId ? `${Paths.sampleAssessmentRepository}/${schoolId}` : Paths.sampleAssessmentRepository;
};

export const getAssessmentSampleAssessmentGroupSolutionUrl = (
  schoolId?: string,
  examTaskGroupSolutionId?: string,
  examTaskGroupSolutionScoreId?: string,
  examinerId?: string,
  examinerFunction?: string,
) => {
  return `${Paths.assessmentSampleAssessmentGroup}/${schoolId}/${examTaskGroupSolutionId}/${examTaskGroupSolutionScoreId}/${examinerId}/${examinerFunction}`;
};

export const getErrorPageUrl = (errorCode: number | string, view?: viewType | string): string => {
  const viewType = view ? `/${view}` : '';
  return `${Paths.error}/${errorCode.toString()}${viewType}`;
};

export const getExamineeListUrl = (sheetCode?: string) => {
  return sheetCode ? `${Paths.examinees}/${sheetCode}` : Paths.examinees;
};

export const getSpecialCaseCardRedirectorUrl = (
  examTaskGroupSolutionScoreId: string,
  taskSolutionSheetId: string,
  assessmentSessionId?: string,
) => {
  return `${Paths.specialCaseCardRedirector}/${examTaskGroupSolutionScoreId}/${taskSolutionSheetId}/${assessmentSessionId}`;
};

export const getAssessment = (examTaskGroupSolutionScoreId: string, assessmentSessionId?: string) => {
  return `${Paths.examTaskGroupSolutionRedirector}/${examTaskGroupSolutionScoreId}/${assessmentSessionId}`;
};

export const getCard = (cardId: string) => {
  return `${Paths.solutionCard}/${cardId}`
}